import React, { useRef, useEffect } from 'react';
import { Text, Divider, Box } from '@chakra-ui/react';

function EmailView({ data }) {
    const iframeRef = useRef(null);

    useEffect(() => {
        const iframe = iframeRef.current;
        if (iframe && data.html) {
            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write(data.html);
            doc.close();
        } else if (iframe && data.text) {
            const doc = iframe.contentWindow.document;
            doc.open();
            doc.write(data.text);
            doc.close();
        }
    }, [data.html, data.text]);

    return (
        <Box p="10px" width='100%'>
            <Text><b>Subject:</b> {data.subject}</Text>
            <Text><b>From:</b> {data.from.text}</Text>
            <Text><b>To:</b> {data.to.text}</Text>
            <Text><b>Date: </b>{data.date}</Text>
            <Divider my="15px" />
            <Box width='100%' height='100%'>
                <iframe ref={iframeRef} style={{ width: '100%', height: '100%', border: 'none' }} />
            </Box>
        </Box>
    );
}

export default EmailView;
